module.exports = __webpack_public_path__ + "img/Text Background 1.be495d7b.png";